import { render } from "./StandardResponses.vue?vue&type=template&id=28d6e6ee"
import script from "./StandardResponses.vue?vue&type=script&lang=js"
export * from "./StandardResponses.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__